module.exports = "<router-outlet></router-outlet>\r\n<ng4-loading-spinner> </ng4-loading-spinner>"